/* Etiquetas multiidoma en inglés. */
export default {
  "codename.clean": "clean",
};
